import React, { useEffect, useState } from "react";
import AdminLayout from "./Common/AdminLayout";
import { TableRowSkeleton } from "./Common/LoadingSkeleton";
import { BsFillEyeFill } from "react-icons/bs";
import { useNavigate, useParams } from "react-router-dom";
import { GetToSubFolder } from "../../Redux/Slices/Folder";
import { IoIosArrowBack } from "react-icons/io";
import "../../asset/new/css/admin-modern.css";
const AdminSubFolder = () => {
  const navigate = useNavigate();
  const [entriesToShow, setEntriesToShow] = useState(10);
  const { id } = useParams();
  const [subfolderdetails, setSubfolderdetails] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(true);

  const handlesubfolder = async () => {
    setLoading(true);
    let res = await GetToSubFolder(id);
    setSubfolderdetails(res?.data || []);
    setLoading(false);
  };

  const handleEntriesChange = (e) => {
    setEntriesToShow(Number(e.target.value));
  };

  // Filter and slice subfolder details
  const filteredDetails = subfolderdetails
    .filter(
      (item) =>
        item?.user_id?.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item?.user_id?.email?.toLowerCase().includes(searchQuery.toLowerCase())
    )
    .slice(0, entriesToShow);

  useEffect(() => {
    handlesubfolder();
    document.title = "Sub-Folder | Admin";
  }, [id]);

  return (
    <AdminLayout
      title="Folder Candidates"
      subtitle="View candidates in this folder"
    >
      {/* Back Button */}
      <div className="mb-4">
        <button
          onClick={() => navigate(-1)}
          className="admin-btn admin-btn-secondary"
        >
          <IoIosArrowBack className="me-1" />
          Back
        </button>
      </div>

      {/* Table Controls */}
      <div className="admin-card" style={{ marginBottom: 'var(--spacing-xl)' }}>
        <div className="admin-card-body">
          <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
            <div>
              <label className="me-2">Show</label>
              <select
                className="admin-select d-inline-block"
                style={{ width: "auto" }}
                value={entriesToShow}
                onChange={handleEntriesChange}
              >
                <option value={10}>10</option>
                <option value={25}>25</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
              </select>
              <span className="ms-2">entries</span>
            </div>
            <input
              type="search"
              placeholder="Search candidates..."
              className="admin-input"
              style={{ maxWidth: "300px" }}
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>
        </div>
      </div>

      {/* Candidates Table */}
      <div className="admin-card">
        <div className="admin-card-body">
          <div className="admin-table-wrapper">
            <table className="admin-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <TableRowSkeleton columns={4} rows={5} />
                ) : filteredDetails.length > 0 ? (
                  filteredDetails.map((item, index) => (
                    <tr key={index}>
                      <td>
                        <div className="d-flex align-items-center">
                          <i className="fas fa-user-circle text-primary me-2"></i>
                          <span>{item?.user_id?.name}</span>
                        </div>
                      </td>
                      <td>{item?.user_id?.email}</td>
                      <td>{item?.user_id?.mobile}</td>
                      <td>
                        <button
                          onClick={() =>
                            navigate(`/Jobseeker/${item?.user_id?._id}`)
                          }
                          className="admin-btn admin-btn-sm admin-btn-primary"
                        >
                          <BsFillEyeFill className="me-1" />
                          View Profile
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4">
                      <div className="admin-empty-state">
                        <i className="fas fa-folder-open fa-3x mb-3"></i>
                        <h4>No Candidates</h4>
                        <p>This folder doesn't contain any candidates yet.</p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default AdminSubFolder;
